export var SocketEvent;
(function (SocketEvent) {
    SocketEvent["CONNECT"] = "connect";
    SocketEvent["DISCONNECT"] = "disconnect";
    SocketEvent["SUBSCRIBE"] = "subscribe";
    SocketEvent["NEWACTIVEUSERS"] = "newactiveusers";
    SocketEvent["USERLEFT"] = "userleft";
    SocketEvent["NEWUSERACTIVITY"] = "newuseractivity";
    SocketEvent["REMOVEUSERACTIVITY"] = "removeuseractivity";
    SocketEvent["CASELOADED"] = "caseloaded";
    SocketEvent["NEWINTERACTIONS"] = "newinteractions";
    SocketEvent["NEWNOTIFICATION"] = "newnotification";
    SocketEvent["NEWDEBTORTRANSACTION"] = "newdebtortransaction";
    SocketEvent["NEWTEAMNOTIFICATION"] = "newteamnotification";
    SocketEvent["UPDATECONTINUED"] = "updatecontinued";
    SocketEvent["NEWUPDATE"] = "newupdate";
    SocketEvent["WATCHINGACCOUNT"] = "watchingaccount";
    SocketEvent["LEAVINGACCOUNT"] = "leavingaccount";
    SocketEvent["NEWVOUCHER"] = "newvoucher";
    SocketEvent["POSTEDVOUCHER"] = "postedvoucher";
    SocketEvent["UNMAPPEDVOUCHER"] = "unmappedvoucher";
    SocketEvent["PATCHEDVOUCHER"] = "patchedvoucher";
    SocketEvent["DELETEDVOUCHER"] = "deletedvoucher";
    SocketEvent["INVALIDATED"] = "invalidated";
    SocketEvent["IMPORTSTATUS"] = "importstatus";
    SocketEvent["PAYMENTPLANMUTATION"] = "paymentplanmutation";
    SocketEvent["NEWPAYMENTPLAN"] = "newpaymentplan";
})(SocketEvent || (SocketEvent = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["WATCHINGCASE"] = "WATCHINGCASE";
    ActivityType["WATCHINGDEBTOR"] = "WATCHINGDEBTOR";
    ActivityType["WRITINGCLIENTNOTE"] = "WRITINGCLIENTNOTE";
    ActivityType["WRITINGDEBTORNOTE"] = "WRITINGDEBTORNOTE";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=index.js.map